export const ModalIds = {
  SELECT_WORKERS: "select-workers-modal",
  DELETE_ACCOUNT: "delete-account-modal",
  CHANGE_PASSWORD: "change-password-modal",
  CONFIRM_PASSWORD_CHANGE: "confirm-password-change-modal",
  DELETE_SSH_KEY: "delete-ssh-key-modal",
  CREATE_SSH_KEY: "create-ssh-key-modal",
  DELETE_CHAT: "delete-chat-modal",
  DELETE_SPACE: "delete-space-modal",
  EDIT_WORKER: "edit-worker-modal",
  LIST_WORKER: "list-worker-modal",
  UNLIST_WORKER: "unlist-worker-modal",
  DELETE_WORKER: "delete-worker-modal",
  DELETE_SPACE_CHAT: "delete-space-chat-modal",
  CREATE_TENANT: "create-tenant-modal",
  INVITE_MEMBERS: "invite-members-modal",
  VIEW_MEMBERS: "view-members-modal",
  CUSTOMIZE_TENANT: "customize-tenant-modal",
  DELETE_TEAM: "delete-team-modal",
  LEAVE_TEAM: "leave-team-modal",
  EDIT_PROVIDER: "edit-provider-modal",
  DELETE_PROVIDER: "delete-provider-modal",
  DELETE_MODEL: "delete-model-modal",
  REDEPLOY_MODEL: "redeploy-model-modal",
  SETUP_NEURAL_PLUGIN_CONFIGURATION: "setup-neural-plugin-configuration-modal",
  DISCONNECT_NEURAL_PLUGIN: "disconnect-neural-plugin-modal",
  ADD_NEW_NP: "add-new-neural-plugin",
  NP_CONFIGURE: "configure-neural-plugin",
  NP_AUTHORIZATION_STEP: "authorize-neural-plugin",
  NP_PUBLISHING_STEP: "publish-neural-plugin",
  NP_PREVIEW: "preview-neural-plugin",
  DELETE_NP: "delete-neural-plugin",
  MANAGE_MODELS: "manage-models-modal",
  PLAYGROUND_CODE: "playground-code",
  VALIDATE_CONNECTION: "validate-connection-modal",
  CUSTOMIZE_CONNECTION: "customize-connection-modal",
  CONFIGURE_CONNECTION_AUTH: "configure-connection-auth-modal",
  PUBLISH_CONNECTION: "publish-connection-modal",
  DELETE_CONNECTION: "delete-connection-modal",
  CLOSE_CONFIRMATION: "close-confirmation-modal",
  AUTHENTICATE_NP_CONNECTION: "authenticate-neural-plugin-connection-modal",
  MODEL_DOWNSCALE_CONFIRMATION: "model-downscale-confirmation-modal",
  CONNECTION_AUTHENTICATION_REQUIRED: "connection-authentication-required-model",
  CONFIRM_TOOL_USE: "confirm-tool-use-modal",
  CONFIRM_TOOL_ACTION: "confirm-tool-action-modal",
  RUN_WORKFLOW: "run-workflow-modal",
  USER_APPROVAL: "user-approval-modal",
  ADAPTIVE_CARD_IFRAME_MODAL: "adaptive-card-iframe-modal",
  APPROVED_TOOLS_MODAL: "approved-tools-modal",
};
